import Tilt2 from 'react-parallax-tilt';
import './Card.css';
import TextSplit, { TextAlign } from '../TextSplit/TextSplit';
import { Component, forwardRef, ReactNode, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";

interface CardProps {
  id: string;
  titleString: string;
  children: ReactNode;
  animation: () => JSX.Element;
  width?: string;
  className?: string;
  height?: string;
}

const Card = forwardRef<HTMLDivElement, CardProps>(({ id, className, titleString, children, animation, width = '100%', height = 'auto' }, ref) => {// Convert newlines to <br /> tags for HTML rendering
  const contentRef = useRef<HTMLDivElement>(null);
  const [tiltHeight, setTiltHeight] = useState('auto');

  useEffect(() => {
    if (!contentRef.current) return;
    const contentHeight = contentRef.current.offsetHeight;
    const computedStyle = window.getComputedStyle(contentRef.current);
    const paddingTop = parseFloat(computedStyle.paddingTop);
    const paddingBottom = parseFloat(computedStyle.paddingBottom);
    const totalHeight = contentHeight + paddingTop + paddingBottom;
    setTiltHeight(`${totalHeight}px`);
  }, [children]);

  return (
    <Box className={`tilt-container ${className}`} id={id} ref={ref}>
      <Tilt2
        glareEnable={true}
        glareMaxOpacity={0.3}
        glareColor="#2c6dee"
        glarePosition="all"
        glareBorderRadius='20px'
        className='card-content'
        style={{ height: tiltHeight, width: width }} // Use passed width
      >
        <Box>
          <Box className="content-container-card" id={`${id}-card`} sx={{fontSize: {sm: '20px', md: '30px', lg: '40px'}}}>
            <Box className='card-title-container' id={`${id}-container`}>
              <Box className='animation-container'>
                {animation()}
              </Box>
              <TextSplit className="card-title" id={`${id}-title`} align={TextAlign.CENTER}>{titleString}</TextSplit>
            </Box>
            <Box className="card-body">
              {children}
            </Box>
          </Box>
        </Box>
      </Tilt2>
    </Box>
  )
});

export default Card;